import type { DataSourceModalArgs } from '@nx/state';
import { useActiveProjectQuery, useFeatureFlag } from '@nx/state';
import { isNotNullish } from '@nx/stdlib';
import { DataSourceModal as DataSourceModalUI, RemoteDataSource } from '@nx/ui';
import { useMemo, useState } from 'react';

import { ExternalDataSources } from './external-data-sources';
import { InstancesDataSource } from './instances-data-source';

export function DataSourceModal(props: DataSourceModalArgs) {
  const [filter, setFilter] = useState(props.instanceNameFilter ?? '');
  const activeProjectRes = useActiveProjectQuery();
  const [externalConnectionsEnabled] = useFeatureFlag('upx:external-connections');
  const [remoteConnectionsEnabled] = useFeatureFlag('upx:remote-connections');

  const dataSources = useMemo(
    () =>
      [
        {
          name: externalConnectionsEnabled ? 'Aura' : (activeProjectRes.data?.name ?? ''),
          element: <InstancesDataSource filter={filter} onFilterChange={setFilter} />,
        },
        externalConnectionsEnabled
          ? {
              name: 'External',
              title: 'External',
              element: <ExternalDataSources />,
            }
          : null,
        remoteConnectionsEnabled
          ? {
              name: 'Remote',
              title: 'Authenticate',
              element: <RemoteDataSource />,
            }
          : null,
      ].filter(isNotNullish),
    [activeProjectRes, filter, externalConnectionsEnabled, remoteConnectionsEnabled, setFilter],
  );

  return <DataSourceModalUI dataSources={dataSources} {...props} />;
}
